import React from 'react';
import PropTypes from 'prop-types';
import {formatNumber} from 'utils/number'


const TextPercent = ({ value, decimals = 2, className, minusColor }) => {   
    let formatted = formatNumber(value, decimals);
    let minusStyle = {};
    if (value < 0){
        let color = minusColor !== undefined ? minusColor : "#ff0000"; //default.        
        minusStyle = {
            color : color
        }
    }        
    if (formatted){
      formatted = formatted + " %";
    }

    if (value === 0){
      formatted = "-";
    }

    return (
        <span className={className} style={minusStyle}>{formatted}</span>
      );
};

TextPercent.propTypes = {
  value: PropTypes.number,
  decimals : PropTypes.number,
  className : PropTypes.string,
  minusColor : PropTypes.string
};

export default TextPercent;
